import React, { useMemo } from 'react';
import { Option, TunzSelect, Utilities } from '@tunz/ifs-react-lib';

import { ReferentialRendererProps } from '../ReferentialSelector/ReferentialSelector';
import { Referential } from '../../Cache/Cache';

const prepareOptions = (items: Referential[]): Option[] =>
	items.map((item) => ({
		label: item.name,
		value: item.name,
		color: Utilities.CurrencyColorProvider.getCurrencyColor(item.name),
	}));

const CurrencyRenderer: React.FC<ReferentialRendererProps> = ({
	items,
	onChange,
	defaultValue,
}) => {
	const preparedOptions = useMemo(() => prepareOptions(items), [items]);
	return <TunzSelect options={preparedOptions} onChange={onChange} defaultValue={defaultValue} />;
};

export default CurrencyRenderer;
